import { render, staticRenderFns } from "./batteryStatistics.vue?vue&type=template&id=28a25612&scoped=true"
import script from "./batteryStatistics.vue?vue&type=script&lang=js"
export * from "./batteryStatistics.vue?vue&type=script&lang=js"
import style0 from "./batteryStatistics.vue?vue&type=style&index=0&id=28a25612&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28a25612",
  null
  
)

export default component.exports